/**
 * @file footer-items.js
 * @description Itens do footer da sidebar (CRA)
 */

import { AccountBoxOutlined } from "@mui/icons-material";
import { ClipboardList, Laptop, LogOut, Settings, User } from "lucide-react";

/**
 * Itens do footer da sidebar
 */
export const FOOTER_ITEMS = [
  {
    icon: ClipboardList,
    label: "Auditoria de Vendas",
    id: "auditoria-vendas",
    href: "/audit/sale-reopen",
    description: "Auditoria de reabertura de vendas",
    permission: "Auditoria",
    action: "islist",
  },
  {
    icon: Laptop,
    label: "Suporte",
    id: "suporte",
    href: "https://trendsuport3.glide.page",
    description: "Acessar suporte",
    permission: "Suporte",
    action: "isinsert",
  },
  {
    icon: User,
    label: "Usuários",
    id: "usuarios",
    href: "/user",
    description: "Gerenciar usuários",
    permission: "Usuario",
    action: "islist",
  },
  {
    icon: Settings,
    label: "Configurações",
    id: "configuracao",
    href: "/listConfiguration",
    description: "Gerenciar configurações",
    permission: "Configuração",
    action: "islist",
  },
];
